import { Mail, Inbox, Sparkles } from 'lucide-react';
import { Email } from '@/types/email';
import { EmailListItem } from './EmailListItem';

interface EmailListProps {
  emails: Email[];
  selectedEmail: Email | null;
  onSelectEmail: (email: Email) => void;
  isLoading: boolean;
}

export const EmailList = ({
  emails,
  selectedEmail,
  onSelectEmail,
  isLoading,
}: EmailListProps) => {
  if (isLoading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 rounded-full gradient-bg animate-pulse" />
          <span className="text-sm text-muted-foreground">Loading inbox...</span>
        </div>
      </div>
    );
  }

  if (emails.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="text-center animate-fade-in">
          <div className="w-20 h-20 rounded-2xl gradient-bg flex items-center justify-center mx-auto mb-4 shadow-glow">
            <Inbox className="w-10 h-10 text-primary-foreground" />
          </div>
          <h3 className="text-lg font-semibold mb-2">Your inbox is empty</h3>
          <p className="text-sm text-muted-foreground max-w-xs">
            Use the email address above to receive emails. They'll appear here instantly.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto">
      <div className="p-2">
        {emails.map((email, index) => (
          <EmailListItem
            key={email.id}
            email={email}
            isSelected={selectedEmail?.id === email.id}
            onSelect={() => onSelectEmail(email)}
            style={{ animationDelay: `${index * 50}ms` }}
          />
        ))}
      </div>
    </div>
  );
};
